<template>
  <div>
    <Checkbox
      class="conduct-inspections__checkbox"
      size="41"
      :checked="item.response"
      @input="handleInput"
    />

  </div>
</template>

<script>
  import Checkbox from '@/_legacy/components/Form/CheckboxButton.vue';

  export default {

    components: { Checkbox },

    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    computed: {},

    methods: {
      handleInput(value) {
        this.$store.commit('conduct/changeResponse', {
          item: this.item.uuid,
          response: value,
          responded: (value === true),
        });
      },
    },
  };
</script>
